import { jsx as _jsx } from "react/jsx-runtime";
import lockupDark from "../../../../droplogo/logo-lockup-dark-rgba.png";
import lockupWhite from "../../../../droplogo/logo-lockup-white.png";
/** Target row height — image scales with fixed aspect from LogoAll crops. */
const heightPx = {
    sm: 20,
    md: 24,
    lg: 36,
};
function LogoImage({ size = "md", tone = "dark" }) {
    const h = heightPx[size];
    const maxW = 192;
    const src = tone === "light" ? lockupWhite : lockupDark;
    return (_jsx("span", { className: "inline-block max-w-[192px] overflow-hidden leading-none", style: { height: h, maxHeight: h, maxWidth: maxW }, children: _jsx("img", { src: src, alt: "drop", style: {
                display: "block",
                height: h,
                maxHeight: h,
                width: "auto",
                maxWidth: maxW,
                objectFit: "contain",
                objectPosition: "left center",
            }, decoding: "async" }) }));
}
/**
 * Approved raster lockups. `tone="dark"` is the black lockup for
 * light surfaces; `tone="light"` is the white lockup, used in the
 * Deep Green nav blocks across customer / dispensary / transporter.
 */
export function Logo({ size = "md", tone = "dark" }) {
    return _jsx(LogoImage, { size: size, tone: tone });
}
//# sourceMappingURL=Logo.js.map